import { render } from "./gic-signup.vue?vue&type=template&id=2a17f34c&scoped=true"
import script from "./gic-signup.vue?vue&type=script&lang=js"
export * from "./gic-signup.vue?vue&type=script&lang=js"

import "./gic-signup.vue?vue&type=style&index=0&id=2a17f34c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a17f34c"]])

export default __exports__